// client/src/api/membership.ts
import api from "./api";

export type MembershipPayment = {
  id: number;
  year: number;
  status: "unpaid" | "pending" | "paid";
  createdAt?: string;
};

export type MembershipPaymentsResponse = {
  success: boolean;
  data: MembershipPayment[];
};

export const getUserPayments = async (): Promise<MembershipPaymentsResponse> => {
  const { data } = await api.get("/membership/user/payments");
  return data;
};

export const markMembershipPaid = async (paymentId?: number) => {
  const { data } = await api.post("/membership/user/mark-paid", {
    paymentId,
  });

  return data;
};